import { c as cn } from './index-6c2bf10f.js';
import React__default from 'react';
import { useIsMobile } from '@sravni/react-utils';

var modules_cf168cce = {"preloader":"_1pwv32e","row":"_199vbox","figure":"_b40r25","pulse":"_1kctdou","figure--polygon":"_1p0l2oo","figure--circle":"_1usvq30","wrapper":"_1lp5kr8","content":"_4yjg2p","content--two-rows":"_10ubg5q","content--mobile-horizontal":"_dtwgkd","block":"_17bqxgn"};
import "../assets/Preloader.css";

var PreloaderPolygon = function (_a) {
    var style = _a.style, className = _a.className;
    return (React__default.createElement("div", { className: cn(modules_cf168cce.figure, modules_cf168cce['figure--polygon'], className), style: style }));
};
var PreloaderCircle = function (_a) {
    var style = _a.style, className = _a.className;
    return (React__default.createElement("div", { className: cn(modules_cf168cce.figure, modules_cf168cce['figure--circle'], className), style: style }));
};
var BlockListPreloader = function (_a) {
    var _b;
    var itemsCount = _a.itemsCount, isPopup = _a.isPopup, isVerticalOnMobile = _a.isVerticalOnMobile;
    var isMobile = useIsMobile();
    return (React__default.createElement("div", { className: modules_cf168cce.wrapper },
        React__default.createElement("div", { className: cn(modules_cf168cce.content, (_b = {},
                _b[modules_cf168cce['content--two-rows']] = itemsCount > 4 && !isPopup && !isMobile,
                // [styles['content--mobile-horizontal']]: isPopup && isMobile,
                _b[modules_cf168cce['content--mobile-horizontal']] = isMobile && !isVerticalOnMobile,
                _b)) }, Array(itemsCount)
            .fill(null)
            .map(function (_, i) { return (React__default.createElement("div", { className: cn(modules_cf168cce.block, modules_cf168cce.preloader), key: "special-offers-preloader-block-" + i },
            React__default.createElement("div", { className: modules_cf168cce.row },
                React__default.createElement("div", { style: { flex: '1 1 auto' } },
                    React__default.createElement(PreloaderPolygon, { style: { width: '70%', height: '20px' } }),
                    React__default.createElement(PreloaderPolygon, { style: { width: '40%' }, className: "h-mt-4" })),
                React__default.createElement(PreloaderCircle, { style: { width: '40px', height: '40px' } })),
            React__default.createElement(PreloaderPolygon, { style: { width: '15%', height: '20px' }, className: "h-mt-16" }),
            React__default.createElement(PreloaderPolygon, { style: { width: '45%' }, className: "h-mt-16" }),
            React__default.createElement(PreloaderPolygon, { style: { width: '90%', height: '20px' }, className: "h-mt-4" }),
            React__default.createElement(PreloaderPolygon, { style: { width: '70%' }, className: "h-mt-16" }))); }))));
};

export { BlockListPreloader as B };
